import { Dialog, TextField } from "@mui/material";
import { defValueLoja, IDataLojas } from "../../types/api/geral/pesquisar-lojas";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import { useState } from "react";

export default function SelectLoja({
    value,
    onChange,
    required = false,
    error = false,
    isDisabled = false,
    extraParams = {},
    fullWidth = true,
    size = "medium",
    possuiBtnLimpar = false,
    label = "Selecione uma loja",
    fieldLabel = "Loja"
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    const inputLabel = value ? `${value.id} - ${value.nome}` : ""

    return (
        <>
            <TextField
                {...{ required, error, fullWidth, size }}
                label={fieldLabel}
                variant="outlined"
                disabled={isDisabled}
                onClick={() => {
                    if (isDisabled) return
                    setOpenModal(true)
                }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: { readOnly: true }
                }}
                value={inputLabel}
                helperText={error ? "Campo obrigatório" : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose, extraParams, possuiBtnLimpar }}
                        title={label}
                        queryPath="/pesquisar-lojas"
                        getItemKey={(item) => item.id}
                        getItemLabel={(item) => `${item.id} - ${item.nome}`}
                        defaultValue={value || defValueLoja}
                        onChange={(value) => {
                            onChange(value as TObjValueLoja)
                            handleClose()
                        }}
                    />
                </Dialog>

            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: IDataLojas | null,
    onChange: (arg: TObjValueLoja | null) => void
    error?: boolean
    required?: boolean;
    isDisabled?: boolean;
    extraParams?: { [key: string]: any };
    fullWidth?: boolean;
    size?: "small" | "medium";
    possuiBtnLimpar?: boolean;
    label?: string;
    fieldLabel?: string;
}

export type TObjValueLoja = IDataLojas